import React, { useState, useEffect, Fragment } from 'react'
import {
  ReportTable,
  HeaderTabs,
  CustomTabPane,
  PaginationRightAligned,
  SearchEventMargin
} from '../../../Reports/styled'
import { Icon, Tabs, Row, Pagination, Col, Divider } from 'antd'
import { Search } from '../../../../components'
import { generateCSV } from '../../../../utils'
import moment from 'moment'
import { isSafari } from 'react-device-detect'
import { report } from '../../../../constants'
import _ from 'lodash'
import { withTranslation } from 'react-i18next'
import ReportHeader from '../../../Reports/components/ReportHeader'
import MarketplaceTypeSelect from '../../../Reports/components/MarketplaceTypeSelect'
import { getOwnerReport } from '../../../../services/api/reports'
import history from '../../../../history'

const { TabPane } = Tabs

const columns = t => [
  {
    title: t('v2:item'),
    dataIndex: 'cover',
    render: cover => {
      return (
        <img
          style={{ width: '70px', height: '50px' }}
          src={cover.resizes && cover.resizes.thumbnail}
          alt="cover"
        />
      )
    },
    width: 70
  },
  {
    dataIndex: 'title',
    textWrap: 'word-break'
  },

  {
    title: t('reports:created_date'),
    dataIndex: 'created_at',
    render: x => {
      return moment(x).format('ll')
    },
    sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
    sortDirections: ['descend', 'ascend']
  },
  {
    title: t('v3:quanity'),
    dataIndex: 'quantity'
  },
  {
    title: t('v3:one_time_price'),
    dataIndex: 'price[0].price',
    render: (text, record) => {
      if (
        record.price &&
        record.price[0] &&
        record.price[0].payment_interval === null
      ) {
        return text
      }
      return 0
    }
  },
  {
    title: t('v3:month_price'),
    dataIndex: 'price[0].price',
    render: (text, record) => {
      if (
        record.price &&
        record.price[0] &&
        record.price[0].payment_interval === 'month'
      ) {
        return text
      }
      return 0
    }
  },
  {
    title: t('v3:year_price'),
    dataIndex: 'price[1].price',
    render: (text, record) => {
      if (
        record.price &&
        record.price[1] &&
        record.price[1].payment_interval === 'year'
      ) {
        return text
      }
      return 0
    }
  },
  {
    title: t('v3:total_amount'),
    dataIndex: 'total_amount'
  },
  {
    title: t('v3:net_amount'),
    dataIndex: 'net_amount'
  }
]

const dateType = {
  allTime: '5',
  today: '1',
  week: '7',
  month: '30',
  year: '12',
  other: '2'
}

const reverseDateType = {
  5: 'all',
  1: 'today',
  7: 'week',
  30: 'month',
  12: 'year',
  2: 'other'
}

const Preview = props => {
  const [page, setPage] = useState(report.PAGE_NUMBER)
  const [pageSize, setPageSize] = useState(report.PAGE_SIZE)
  const [search, setSearch] = useState('')
  const [sortBy, setSortBy] = useState('')
  const [workshopDateType, setWorkshopDateType] = useState('5')
  const [workshopSearchType, setWorkshopSearchType] = useState('')
  const [dateTo, setDateTo] = useState(null)
  const [dateFrom, setDateFrom] = useState(null)
  const [marketLoading, setMarketLoading] = useState(true)
  const [list, setList] = useState([])
  const [totalPagination, setTotalPagination] = useState(0)
  const [courses, setCourses] = useState([])

  useEffect(() => {
    const reportObj = {
      type: 'channel',
      offset: createOffset(page, pageSize),
      limit: pageSize,
      date: 'allTime',
      search: '',
      from: '',
      to: ''
    }
    callreportFunc(reportObj)
  }, [])

  const callreportFunc = async reportObj => {
    try {
      const res = await getOwnerReport(reportObj)

      setList(res.data.channels)
      setCourses(res.data.channels)
      setTotalPagination(res.data.pagination.total)
      setMarketLoading(false)
    } catch (error) {
      console.error(error)
      setMarketLoading(false)
    }
  }

  const download = () => {
    const coursesArray = list || []
    const dataCSV = coursesArray.map(x => ({
      id: x.id,
      title: x.title,
      created_at: moment(x.created_at).format('YYYY-MM-DD'),
      net_amount: x.net_amount,
      quantity: x.quantity,
      price: x.price[0],
      price: x.price[1],
      total_amount: x.total_amount,
      total: x.total
    }))
    const header = [
      '#',
      'Title',
      'Created at',
      'Net Amount',
      'Quantity',
      'Price',
      'Toatl Amount',
      'Total'
    ]

    if (!isSafari) {
      let ele = document.createElement('a')
      ele.setAttribute(
        'href',
        'data:text/csv;charset=utf-8,' +
          encodeURIComponent(generateCSV(dataCSV, header))
      )
      ele.setAttribute('download', 'channel-report.csv')
      document.body.appendChild(ele)
      ele.click()
    } else {
      let ele = document.createElement('a')
      ele.setAttribute(
        'href',
        'data:text/csv;charset=utf-8,' +
          encodeURIComponent(generateCSV(dataCSV, header))
      )
      ele.setAttribute('download', 'channel-report.csv')
      ele.click()
    }
  }

  const createOffset = (page, pageSize) => page * pageSize - pageSize

  const onChangePagination = async page => {
    setMarketLoading(true)

    const requestOptions = {
      type: 'channel',
      offset: createOffset(page, pageSize),
      limit: pageSize,
      ...(workshopSearchType && {
        date: workshopSearchType === 'allTime' ? 'all' : workshopSearchType
      }),
      search: search,
      date:
        reverseDateType[workshopDateType] === 'other'
          ? ''
          : reverseDateType[workshopDateType],
      from: reverseDateType[workshopDateType] === 'other' ? dateFrom : '',
      to: reverseDateType[workshopDateType] === 'other' ? dateTo : ''
    }

    setPage(page)

    try {
      const res = await getOwnerReport(requestOptions)
      setList(res.data.channels)
      setCourses(res.data.channels)

      setTotalPagination(res.data.pagination.total)
      setMarketLoading(false)
    } catch (error) {
      console.error(error)
      setMarketLoading(false)
    }
  }

  const onSearch = _.debounce(value => {
    setMarketLoading(true)
    setSearch(value)
    const requestOptions = {
      type: 'channel',
      offset: createOffset(1, pageSize),
      limit: pageSize,
      ...(workshopSearchType && {
        date: workshopSearchType === 'allTime' ? 'all' : workshopSearchType
      }),
      search: value,
      title: value,
      date:
        reverseDateType[workshopDateType] === 'other'
          ? ''
          : reverseDateType[workshopDateType],
      from: reverseDateType[workshopDateType] === 'other' ? dateFrom : '',
      to: reverseDateType[workshopDateType] === 'other' ? dateTo : ''
    }
    setPage(1)

    try {
      const marketFilter = async () => {
        const res = await getOwnerReport(requestOptions)
        setList(res.data.channels)
        setCourses(res.data.channels)

        setTotalPagination(res.data.pagination.total)
        setMarketLoading(false)
      }
      marketFilter()
    } catch (error) {
      console.error(error)
      setMarketLoading(false)
    }
  }, 1000)

  const handleSortByChange = async value => {
    setMarketLoading(true)

    const defaultProps = {
      type: 'channel',
      offset: createOffset(page, pageSize),
      limit: pageSize,
      date: 'today',
      search: search,
      from: '',
      to: ''
    }

    if (value === '1') {
      setSortBy('today')
      setWorkshopDateType(value)

      try {
        const res = await getOwnerReport({
          ...defaultProps
        })
        setCourses(res.data.channels)
        setTotalPagination(res.data.pagination.total)
      } catch (error) {
        console.error(error)
      }
    } else if (value === '7') {
      setSortBy('week')
      setWorkshopDateType(value)

      try {
        const res = await getOwnerReport({
          ...defaultProps,
          date: 'week'
        })
        setCourses(res.data.channels)
        setTotalPagination(res.data.pagination.total)
      } catch (error) {
        console.error(error)
      }
    } else if (value === '30') {
      setSortBy('month')
      setWorkshopDateType(value)

      try {
        const res = await getOwnerReport({
          ...defaultProps,
          date: 'month'
        })
        setCourses(res.data.channels)
        setTotalPagination(res.data.pagination.total)
      } catch (error) {
        console.error(error)
      }
    } else if (value === '12') {
      setSortBy('year')
      setWorkshopDateType(value)

      try {
        const res = await getOwnerReport({
          ...defaultProps,
          date: 'year'
        })
        setCourses(res.data.channels)
        setTotalPagination(res.data.pagination.total)
      } catch (error) {
        console.error(error)
      }
    } else if (value === '5') {
      setSortBy('all')
      setWorkshopDateType(value)

      try {
        const res = await getOwnerReport({
          ...defaultProps,
          date: 'all'
        })
        setCourses(res.data.channels)
        setTotalPagination(res.data.pagination.total)
      } catch (error) {
        console.error(error)
      }
    } else if (value === '2') {
      setSortBy('other')
      setWorkshopDateType(value)
    }
    setMarketLoading(false)
  }

  const handleDate = val => {
    setDateFrom(val[0])
    setDateTo(val[1])
    fetchData()
  }

  const fetchData = async () => {
    setMarketLoading(true)

    const requestOptions = {
      type: 'channel',
      offset: createOffset(page, pageSize),
      limit: pageSize,
      date: '',
      from: dateFrom,
      to: dateTo,
      search: search
    }

    try {
      const res = await getOwnerReport(requestOptions)
      setMarketLoading(false)
      setCourses(res.data.channels)
      setTotalPagination(res.data.pagination.total)
    } catch (error) {
      console.error(error)
      setMarketLoading(false)
    }
  }

  const callbackTabClicked = (key, event) => {
    if (key === '0') {
      history.push(`/reports`, 'marketplace')
    } else if (key === '1') {
      history.push('/reports')
    } else if (key === '2') {
      history.push('/reports', 'user')
    }
  }

  const {
    t,
    user: {
      info: { organization }
    }
  } = props

  const lang = localStorage.getItem('i18nextLng')

  return (
    <Fragment>
      <div className="content-warp">
        <div
          className="report-warp sharelook-table"
          style={{ direction: 'ltr' }}
        >
          <HeaderTabs
            defaultActiveKey="9"
            animated={false}
            // onChange={changeTab}
            onTabClick={callbackTabClicked}
            tabBarExtraContent={
              <ReportHeader
                workshopDateType={workshopDateType}
                dateChange={value => handleSortByChange(value)}
                download={download}
                handleDate={(date, dateString) => handleDate(dateString)}
                dateFrom={dateFrom}
                dateTo={dateTo}
              />
            }
          >
            <TabPane
              tab={
                <CustomTabPane>
                  <Icon type="left" style={{ fontSize: '18px' }} />
                </CustomTabPane>
              }
              key="0"
            />
            <TabPane tab={t('reports:workshop_report')} key="1"></TabPane>
            <TabPane tab={t('reports:user_report')} key="2"></TabPane>
            <TabPane
              className="sharelok-marketplace-report"
              tab={t('v4:marketplace_report')}
              key="9"
              style={{
                direction:
                  lang === 'hebrew' || lang === 'arabic' ? 'rtl' : 'ltr'
              }}
            >
              <React.Fragment>
                <MarketplaceTypeSelect defaultValue="channel" />

                {/* {!hasFetched ? (
                <Spinner />
              ) : ( */}
                <Row>
                  <ReportTable
                    rowKey="id"
                    columns={columns(t)}
                    dataSource={courses}
                    pagination={false}
                    loading={marketLoading}
                    borderRadius
                    onRow={(record, rowIndex) => {
                      return {
                        onClick: e =>
                          history.push(
                            `/reports/market-place/channel/` + record.id
                          )
                      }
                    }}
                    title={() => (
                      <>
                        <Row
                          className="sharelook-course-wrapper"
                          style={{ marginLeft: '30px', marginTop: '3px' }}
                        >
                          <Col span={5}>
                            <SearchEventMargin>
                              <Search
                                placeholder={t('v3:search_channel')}
                                onChange={e => onSearch(e.target.value)}
                              />
                            </SearchEventMargin>
                          </Col>
                          <Col span={11} />
                          <Col className="report-title" span={3} push={1}>
                            {t('v4:total')} {totalPagination} {''}
                            {t('v3:report_channel')}
                          </Col>
                          <Col span={4} style={{ marginTop: '14px' }}>
                            <PaginationRightAligned margin>
                              <Pagination
                                total={totalPagination}
                                current={page}
                                pageSize={pageSize}
                                onChange={onChangePagination}
                                simple
                              />
                            </PaginationRightAligned>
                          </Col>
                        </Row>
                        <Divider style={{ margin: '0px' }} />
                      </>
                    )}
                  />
                </Row>
                {/* )} */}
              </React.Fragment>
            </TabPane>
          </HeaderTabs>
        </div>
      </div>
    </Fragment>
  )
}

export default withTranslation('report')(Preview)
